<!-- 封装后的elm轮播图，展示图片和说明文字 -->
<template>
  <div class="mainCarousel">
    <el-carousel trigger="click" :height="height">
      <el-carousel-item class="mainCarousel-inner" v-for="(item,index) in content" :key="index">
        <img class="mainCarouselImg" :src="item.imgSrc" alt="主图">
        <div class="description" @click="$router.push(`/index/news?id=${encodeURIComponent(item.id)}`)">
          <p class="text" :title="item.text" >{{ item.text }}</p>
        </div>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
const DISPLAY_CHANGE = "change";
export default {
  name: "mainCarousel",
  props: {
    height: {
      type: String,
      default: "150px"
    },
    // content: [{imgSrc: '', text: ''}, ...]
    content: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      options: [],
      selectedOptions: 0
    };
  },
  methods: {
    handleChange(e) {
      this.$emit(DISPLAY_CHANGE, this.selectedOptions);
    }
  }
};
</script>
<style lang="scss">
.mainCarouselImg {
  height: 100%;
  width: 100%;
}
.mainCarousel-inner{
 height: 100%;
}
.mainCarousel {
  position: relative;
  .el-carousel{
    display: flex;
    align-items: center;
    height: 100%;
  }
  .el-carousel__container{
    width: 100%;
  }
  ul.el-carousel__indicators {
    margin-bottom: 50px;
    background: #00000040;
    padding: 0 30px;
  }
  .description {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 45px;
    background: #0087d3;
    color: #fff;
    opacity: 0.7;
    transition: opacity 0.2s;
    cursor: pointer;
    &:hover {
      opacity: 0.9;
    }
    .text {
      margin: 0 25px;
      line-height: 45px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      text-align: left;
      font-size: 20px;
    }
  }
}
</style>